import MuiButton from './MuiButton';
import MuiLoadingButton from './MuiLoadingButton';
import MuiCheckbox from './MuiCheckbox';
import MuiRadio from './MuiRadio';
import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiFormLabel from './MuiFormLabel';
import MuiInputLabel from "./MuiInputLabel";
import MuiChip from './MuiChip';
import MuiCard from "./MuiCard";
import MuiInputBase from './MuiInputBase';
import MuiBreadcrumbs from './MuiBreadcrumbs';
import MuiIconButton from './MuiIconButton';
import MuiAccordion from './MuiAccordion';
import MuiTab from './MuiTab';
import MuiTabs from './MuiTabs';

const index = {
    MuiButton,
    MuiLoadingButton,
    MuiCheckbox,
    MuiRadio,
    MuiOutlinedInput,
    MuiFormLabel,
    MuiInputLabel,
    MuiChip,
    MuiCard,
    MuiInputBase,
    MuiBreadcrumbs,
    MuiIconButton,
    MuiAccordion,
    MuiTab,
    MuiTabs
};

export default index;
